
import baseURL from "../common/axios";
class ManufactureContactDetailsService {
    insert(objinsert) {
        debugger;
        return baseURL.httpMSInventoryUrl.post("ManufactureContactDetails/Create", objinsert);
    }
    getdata() {
        debugger;
        return baseURL.httpMSInventoryUrl.get("ManufactureContactDetails/List");
    }
    Edit(EditID) {
        debugger;
        return baseURL.httpMSInventoryUrl.get(
            "ManufactureContactDetails/Get?id=" + EditID + ""
        );
    }
    Delete(DelID) {
        debugger;
        return baseURL.httpMSInventoryUrl.delete(
            "ManufactureContactDetails/Delete?id=" + DelID
        );
    }
    //Active
    active(DelID, Status) {
        debugger;
        return baseURL.httpMSInventoryUrl.put(
            "ManufactureContactDetails/Active?id=" + DelID + "&Status=" + Status + ""
        );
    }
    Update(objupdate) {
        debugger;
        return baseURL.httpMSInventoryUrl.post("ManufactureContactDetails/Update", objupdate);
    }

    //FileInsert
    Fileinsert(objinsert) {
        debugger;
        return baseURL.httpMSInventoryUrl.post(
            "ManufactureImagesMAS/Create",
            objinsert
        );
    }

    //Get Files by Manufacture Id
    GetFilesByManufactureId(ManufactureId) {
        debugger;
        return baseURL.httpMSInventoryUrl.get(
            "ManufactureImagesMAS/ListManufactureImagesMASByManufactureContactDetailsId?ManufactureId=" +
            ManufactureId +
            ""
        );
    }
}
export default new ManufactureContactDetailsService();
